module.exports = __webpack_public_path__ + "img/headbg.b85f4ebd.png";